// Official Nepal government & authority sources — used for citation blocks.
// LAST_VERIFIED should be updated whenever content is re-checked against sources.
export const LAST_VERIFIED = '2026-07-13';

export const OFFICIAL_SOURCES = {
	immigration: {
		name: 'Department of Immigration, Government of Nepal',
		url: 'https://www.immigration.gov.np/en/page/tourist-visa',
	},
	immigrationTia: {
		name: 'Immigration Office, Tribhuvan International Airport',
		url: 'https://tia.immigration.gov.np/en/page/faq',
	},
	immigrationOnline: {
		name: 'Nepal Online Visa Application (Department of Immigration)',
		url: 'http://nepaliport.immigration.gov.np/',
	},
	ntb: {
		name: 'Nepal Tourism Board',
		url: 'https://ntb.gov.np/plan-your-trip/before-you-come/tourist-visa',
	},
	ntbMain: {
		name: 'Nepal Tourism Board',
		url: 'https://ntb.gov.np/',
	},
	caan: {
		name: 'Civil Aviation Authority of Nepal (CAAN)',
		url: 'https://www.caan.gov.np/',
	},
	ntnc: {
		name: 'National Trust for Nature Conservation (ACAP permits)',
		url: 'https://ntnc.org.np/',
	},
	dnp: {
		name: 'Department of National Parks and Wildlife Conservation',
		url: 'https://dnpwc.gov.np/',
	},
	customs: {
		name: 'Department of Customs, Government of Nepal',
		url: 'https://www.customs.gov.np/',
	},
	archaeology: {
		name: 'Department of Archaeology (export certificates)',
		url: 'https://www.doa.gov.np/',
	},
	unescoNepal: {
		name: 'UNESCO World Heritage Centre — Nepal',
		url: 'https://whc.unesco.org/en/statesparties/np',
	},
	ntc: {
		name: 'Nepal Telecom (NTC)',
		url: 'https://www.ntc.net.np/services/nt-wifi',
	},
	ncell: {
		name: 'Ncell Axiata',
		url: 'https://www.ncell.com.np/en/individual',
	},
	touristPolice: {
		name: 'Tourist Police Nepal (NTB)',
		url: 'https://ntb.gov.np/en/plan-your-trip/before-you-come/tourist-police',
	},
	tourismDept: {
		name: 'Department of Tourism, Nepal',
		url: 'https://tourismdepartment.gov.np/',
	},
	hra: {
		name: 'Himalayan Rescue Association (HRA)',
		url: 'https://himalayanrescue.org/',
	},
	taan: {
		name: 'Trekking Agencies Association of Nepal (TAAN)',
		url: 'https://www.taan.org.np/',
	},
	ntbParkFees: {
		name: 'NTB — National park entry fees',
		url: 'https://ntb.gov.np/en/plan-your-trip/before-you-come/park-entry-fees',
	},
};

// Fee figures sourced from immigration.gov.np tourist visa page & NTB — July 2026.
// subject_to_change: true on all regulatory content.
export const VISA_FEES_USD = {
	15: 30,
	30: 50,
	90: 125,
};

export const VISA_EXTENSION = {
	minimumDays: 15,
	minimumFeeUsd: 45,
	perDayUsd: 3,
	overstayFinePerDayUsd: 5,
	maxDaysPerYear: 150,
};
